import React from 'react'
import PropTypes from 'prop-types'
import { Card, Col, Row } from 'react-bootstrap'
import { Trash } from 'react-bootstrap-icons'
import FormRepeater from '../../../../../../../common/FormReapeater.jsx'
import ButtonWithIcon from '../../../../../../../common/ButtonWithIcon.jsx'
import InputWiz from '../../../../../../../common/inputs/wizard/InputWiz.jsx'
import { HeaderTitle } from '../../../../../../../common/HeaderTitle.jsx'

const MAX_KONTAKT = 3

const KontaktRow = ({ row, setRow, idx, remove, parent, wiz }) => (
    <Card className={'d-flex flex-column gap-2 mb-3 w-100'}>
        <Card.Header className={'d-flex justify-content-between align-items-center'}>
            <HeaderTitle noHr size={'fs-6'} title={`Osoba do kontaktu ${idx + 1}`} />
            <ButtonWithIcon
                text={`Usuń osobę ${idx + 1}`}
                onClick={() => remove(idx)}
                icon={<Trash />}
                variant={'danger'}
                size={'md'}
            />
        </Card.Header>

        <Card.Body className={'p-3'}>
            <Row className="align-items-end mb-3">
                <Col xs={12} md={6}>
                    <InputWiz
                        wiz={wiz}
                        keyName={`${parent}.${idx}.imie`}
                        row={row}
                        setRow={setRow}
                        idx={idx}
                        label="Imię"
                    />
                </Col>
                <Col xs={12} md={6}>
                    <InputWiz
                        wiz={wiz}
                        keyName={`${parent}.${idx}.nazwisko`}
                        row={row}
                        setRow={setRow}
                        idx={idx}
                        label="Nazwisko"
                    />
                </Col>
            </Row>
            <Row className="align-items-end">
                <Col xs={12} md={4}>
                    <InputWiz
                        wiz={wiz}
                        keyName={`${parent}.${idx}.stanowisko`}
                        row={row}
                        setRow={setRow}
                        idx={idx}
                        label="Stanowisko"
                    />
                </Col>
                <Col xs={12} md={4}>
                    <InputWiz
                        wiz={wiz}
                        keyName={`${parent}.${idx}.telefon`}
                        row={row}
                        setRow={setRow}
                        idx={idx}
                        label="Telefon"
                    />
                </Col>
                <Col xs={12} md={4}>
                    <InputWiz
                        wiz={wiz}
                        keyName={`${parent}.${idx}.email`}
                        row={row}
                        setRow={setRow}
                        idx={idx}
                        label="Email"
                    />
                </Col>
            </Row>
        </Card.Body>
    </Card>
)

KontaktRow.propTypes = {
    row: PropTypes.object,
    setRow: PropTypes.func,
    idx: PropTypes.number,
    remove: PropTypes.func,
    parent: PropTypes.string,
    wiz: PropTypes.any,
}

export const KontaktRepeater = (props) => {
    const parent = props.parentListName || 'kontakt_list'
    const raw = Array.isArray(props.wiz?.form?.[parent]) ? props.wiz.form[parent] : []
    const list = raw.map((item) => (Array.isArray(item) ? {} : (item || {})))

    const handleListChange = (newList) => {
        props.wiz.setValue(parent, newList)
    }

    return (
        <FormRepeater
            value={list}
            onChange={handleListChange}
            addButtonText="Dodaj osobę do kontaktu"
            addBtnDisabled={list.length >= MAX_KONTAKT}
            hideNativeDelete
            className={'w-100'}
            form={(row, setRow, idx, remove) => (
                <KontaktRow
                    row={row}
                    setRow={setRow}
                    idx={idx}
                    remove={remove}
                    parent={parent}
                    wiz={props.wiz}
                />
            )}
        />
    )
}

KontaktRepeater.propTypes = {
    wiz: PropTypes.any.isRequired,
    parentListName: PropTypes.string,
}

export default KontaktRepeater
